import * as React from 'react';

import BasePaycodeListLayout from './BasePaycodeListLayout';
import CreatePaycodePopup from '../containers/codes/CreatePaycodePopup';


export default (params) => {
  return BasePaycodeListLayout(
    <CreatePaycodePopup />
  );
};
